// extracted by mini-css-extract-plugin
module.exports = {"Features":"Features_Features__29s2V","Features-Hero":"Features_Features-Hero__2V8sE","Features-Aside":"Features_Features-Aside__1utLC"};